<template lang="html">
  <div class="">
    <polinization-details v-if="view_mode" :model="variables">
      <template slot="actions">
        <process-controls
          v-if="Object.keys(variables).length > 0"
          :record="variables"
          @action="processAction"
        />
      </template>
    </polinization-details>

    <polinization-form
      v-if="!view_mode"
      ref="polinizationForm"
      :init-model="init_model"
      :run-validation="runValidation"
      :messages="messages"
      class="col-md-10 offset-md-1"
      @validForm="validForm"
      @modelUpdated="updateModel"
    >
      <template slot="actions">
  <process-controls
    v-if="Object.keys(variables).length > 0"
    :record="variables"
    :is-form="true"
    @action="processAction"
  />
  <n-button
    v-if="Object.keys(variables).length == 0"
    simple=""
    @click.native="view_mode = true"
  >
    Cerrar
  </n-button>
  <n-button
    v-if="Object.keys(variables).length == 0"
    type="primary"
    @click.native="validate()"
  >
    {{ saveText }}
  </n-button>
</template>
    </polinization-form>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PolinizationDetails from "@/views/Labors/Polinizations/PolinizationDetails";
import PolinizationForm from "@/views/Labors/Polinizations/PolinizationForm";
import ProcessControls from "@/views/TaskList/Components/ProcessControls";

export default {
  components: {
    PolinizationDetails,
    PolinizationForm,
    ProcessControls,
  },
  props: {
    variables: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      title: "Detalles de la polinización",
      back_text: "Polinizaciones",
      back_custom_target: {
        name: "records-view",
        params: {
          processKey: "polinizations",
        },
      },
      view_mode: true,
      runValidation: false,
      messages: {},
      init_model: {},
      model: {
        workflow: {
          state: "new",
        },
      },
      decision: "",
      transitions_with_update: ["update_task"],
      states_which_start_with_form: ["reporting", "new"],
    };
  },
  computed: {
    saveText() {
      if (this.model.workflow.hasOwnProperty("state")) {
        if (this.model.workflow.state != "new") {
          return "Guardar cambios";
        } else {
          return "Registrar";
        }
      } else {
        if (this.$HELPERS.isFuture(this.model.date)) {
          return "Programar";
        } else if (this.$HELPERS.isPast(this.model.date)) {
          return "Registrar";
        } else {
          return "Iniciar";
        }
      }
    },
  },
  created() {
    if (Object.keys(this.variables).length > 0) {
      this.model = this.preProcessVariables();
      this.init_model = this.$COPY.copy(this.model);
    }
    if (this.states_which_start_with_form.includes(this.model.workflow.state)) {
      this.view_mode = false;
    }
    this.$emit("setBackText", this.back_text);
    this.$emit("setBackCustomTarget", this.back_custom_target);
    this.$emit("setTitle", this.title);
  },
  methods: {
    preProcessVariables() {
      let init_model = this.$COPY.copy(this.variables);
      init_model.sector_ids = init_model.sector_ids.map((i) => i.$oid);
      return init_model;
    },
    processAction(action) {
      this.decision = action;
      if (this.transitions_with_update.includes(action) && this.view_mode) {
        this.view_mode = false;
      } else {
        this.startOrCompleteTask();
      }
    },
    updateModel(model) {
      this.model = this.$COPY.copy(model);
    },
    validate() {
      this.loader = true;
      this.messages = {};
      this.runValidation = true;
    },
    validForm(isValid) {
      this.runValidation = false;
      isValid ? this.startOrCompleteTask() : (this.loader = false);
    },
    startOrCompleteTask() {
      if (this.model.workflow.hasOwnProperty("state")) {
        if (this.model.workflow.state != "new") {
          this.completeTask();
        } else {
          this.start();
        }
      } else {
        this.start();
      }
    },
    start() {
      let vm = this;
      this.Services.Polinizations.createPolinization(
        this.model.farm_id,
        this.model
      )
        .then((response) => {
          Swal.fire({
            title: response.data.messages,
            icon: "success",
          }).then(() => {
            vm.$router.push({
              name: "records-view",
              params: {
                processKey: "polinizations",
              },
            });
          });
        })
        .catch((error) => {
          console.log(error);
          if (typeof error.response.data != "string") {
            vm.messages = error.response.data;
          }
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    completeTask() {
      this.$emit(
        "completeTask",
        this.$route.params.processKey,
        this.$route.params.id,
        this.model,
        this.decision
      );
    },
  },
};
</script>

<style lang="sass" scoped></style>
